import { Super } from './super.model';

export class BlogCat extends Super<BlogCat> {

    public title: string;
    public description: string;    
}